// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import logo from '../../../../img/logo.svg';

type Props = {
  errorMessage: string,
}

function MarketingEmptyTile({ errorMessage }: Props) {
  return (
    <div className="marketing-empty-tile">
      <img className="logo" src={logo} alt="logo" />
      <Translate value={errorMessage} />
    </div>
  );
}

export default MarketingEmptyTile;
